// @ts-ignore
import easyScroll from 'easy-scroll';

export interface ScrollToParams {
  elementSelector: string;
  direction?: 'bottom' | 'top';
  duration?: number;
  easingPreset?: string;
  scrollAmount: number;
}

// 滚动到第一个错误的FormItem
const scrollToFormFirstError = () => {
  const elements = document.querySelectorAll('.form-item.client-error, .form-item.server-error');
  const menuHeader = document.querySelectorAll('.mpc-header');
  if (elements.length) {
    const to = elements[0].getBoundingClientRect().top;
    const headerHeight = menuHeader.length ? menuHeader[0].getBoundingClientRect().height : 0;
    if (to !== 0) {
      const scrollAmount = to - headerHeight > 0 ? to - headerHeight : headerHeight - to;
      const direction = to - headerHeight > 0 ? 'bottom' : 'top';
      easyScroll({
        'scrollableDomEle': document.documentElement,
        'direction': direction,
        'duration': 500,
        'easingPreset': 'easeInQuad',
        'scrollAmount': Math.abs(scrollAmount),
      });
    }
  }
};

export const easeSrcollTo = (options: ScrollToParams) => {
  const {
    elementSelector, direction = 'bottom', duration, easingPreset, scrollAmount,
  } = options;
  const elements = document.querySelectorAll(elementSelector);
  if (elements.length) {
    easyScroll({
      'scrollableDomEle': elements[0],
      'direction': direction,
      'duration': duration || 500,
      'easingPreset': easingPreset || 'easeInQuad',
      'scrollAmount': Math.abs(scrollAmount),
    });
  }
};

export default {
  scrollToFormFirstError,
};
